import React from "react";
import ReceiptHeader from "../../components/ReceiptHeader";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { axiosget } from "../../helpers/httprequest";
import Loader from "../../components/Loader";
import ErrorResponse from "../../components/ErrorResponse";
import QRCode from "react-qr-code";
import is_money from "../../helpers/is_money";
import is_null from "../../helpers/is_null";
import { appHost } from "../../helpers/uri";

const AcceptanceReceipt = () => {
  const { id } = useParams();
  const { data, isLoading, error } = useQuery({
    queryKey: ["acceptanceReceiptInfo"],
    queryFn: async () => {
      const req = await axiosget(`ms_acceptance_fee_rrr/receipt/${id}`);
      return req?.data;
    },
  });
  if (!is_null(data)) {
    setTimeout(() => window.print(), 500);
  }
  return (
    <>
      {isLoading && <Loader />}
      {error && <ErrorResponse type={`danger`} message={`Local server error: ${error}`} />}
      {data?.message !== undefined && <ErrorResponse type={`danger`} message={data?.message} />}
      {data?.message === undefined && (
        <div
          id="printDocument"
          style={{
            content: " ",
            display: "block",
            backgroundImage: data?.acceptanceFee?.status ? `url('${appHost}/images/paid.png')` : `url('${appHost}/images/not-paid.png')`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "50% 0",
            backgroundSize: "550px 550px",
          }}
        >
          <ReceiptHeader office={`PAYMENT RECEIPT Bursary Department`} />
          <div className="container">
            <div className="row">
              <div className="col-md-8">
                <div className="row">
                  <div className="col-md-12">
                    Name: <b> {data?.details?.payerName}</b>
                  </div>
                  <div className="col-md-12">
                    Time: <b>{data?.createdAt}</b>
                  </div>
                  <div className="col-md-12">
                    Admission Code: <b> {data?.code}</b>
                  </div>
                  <div className="col-md-12">
                    Email Address: <b>{data?.applicant?.emailaddress}</b>
                  </div>
                  <div className="col-md-12">
                    Phone Number: <b>{data?.applicant?.phonenumber}</b>
                  </div>
                  <div className="col-md-12">
                    Amount: <b>{is_money(data?.acceptanceFee?.details?.amount)}</b>
                  </div>
                  <div className="col-md-12">
                    Transaction Status: <b>{data?.acceptanceFee?.status ? "Paid" : "Not Paid"}</b>
                  </div>
                  <div className="col-md-12">
                    Programme:{" "}
                    <b>
                      {data?.programme?.code} {data?.programme?.name}
                    </b>
                  </div>
                  <div className="col-md-12 text-center">REMITA RRR</div>
                  <div className="col-md-12 text-center">
                    <h1 style={{ fontSize: 80 }}>{data?.acceptanceFee?.RRR}</h1>
                  </div>
                </div>
              </div>
              <div className="col-md-4 mt-1">
                <QRCode
                  value={btoa(
                    JSON.stringify({
                      rrr: data?.RRR,
                      name: data?.details?.payerName,
                    })
                  )}
                />
              </div>
              <div className="col-md-12 text-center">{data?.acceptanceFee?.details?.description}</div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AcceptanceReceipt;
